import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";

export const DoctorHolidaysTable = ({ next6Months, monthlyHolidays, removeHoliday }) => {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 750 }} className="text-sm" aria-labelledby="tableTitle" size={"medium"}>
        <TableHead>
          <TableRow className="bg-gray-100">
            {next6Months.map((month, ind) => (
              <TableCell key={ind} align="center" padding="normal" className="border border-gray-200">
                <span className="font-semibold text-sm text-gray-500">{month}</span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ height: "60vh" }} className="text-gray-500">
            {next6Months.map((month, ind) => (
              <TableCell
                key={ind}
                align="center"
                padding="normal"
                className="border border-gray-200"
                sx={{ width: "16.67%", verticalAlign: monthlyHolidays?.[month]?.length ? "top" : "middle" }}
              >
                <span className="text-gray-600 text-xs">{`${monthlyHolidays?.[month]?.length ? new Set(monthlyHolidays[month].flat().map((a) => a.date)).size : "No"} Holidays`}</span>
                {monthlyHolidays?.[month]?.map((range, ind) => (
                  <div key={ind} className="my-2 p-2 bg-gray-100 border border-gray-200 rounded-lg flex justify-between">
                    <span className="text-gray-600 text-xs">
                      {range.length > 1 && range[0].date != range[range.length - 1].date
                        ? `${moment(range[0].date).format("ddd D MMM")} - ${moment(range[range.length - 1].date).format("ddd D MMM")}`
                        : moment(range[0].date).format("ddd D MMM")}
                    </span>
                    <div className="text-red-500" onClick={() => removeHoliday(range)}>
                      <span className="cursor-pointer">
                        <img src="https://views.medibuddy.in/providerUi/assets/deleteIcon.svg"></img>
                      </span>
                    </div>
                  </div>
                ))}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
